import { useTranslation } from 'next-i18next';
import useFileHandler from 'src/hooks/useFileHandler';
import { Icon, ProfileImage, ProfileImageButton, ProfileImageLabel, ProfileImageMainBadge } from './styles';
interface Props {
  isMain?: boolean;
  profileImageUrl: string;
  onDelete: () => void;
  onMainImageChange?: (file: File) => void;
}
const ProfileImageCard = ({
  isMain = false,
  profileImageUrl,
  onDelete,
  onMainImageChange
}: Props) => {
  const {
    t
  } = useTranslation();
  const handleChangeFile = useFileHandler(onMainImageChange ?? (() => {}));
  return <ProfileImage style={{
    backgroundImage: `url(${profileImageUrl})`
  }} data-sentry-element="ProfileImage" data-sentry-component="ProfileImageCard" data-sentry-source-file="ProfileImageCard.tsx">
      {isMain ? <>
          <ProfileImageMainBadge>{t('PROFILE_MAIN_IMAGE')}</ProfileImageMainBadge>
          <ProfileImageLabel htmlFor='profile-image-edit-main-file'>
            <Icon src='/images/icons/icEdit.svg' alt='Edit First Profile Card' />
            <input hidden type='file' id='profile-image-edit-main-file' onChange={handleChangeFile} accept='image/*' />
          </ProfileImageLabel>
        </> : <ProfileImageButton onClick={onDelete}>
          <Icon src='/images/icons/icFriendDeleteLarge.svg' alt='Delete Profile Card' />
        </ProfileImageButton>}
    </ProfileImage>;
};
export default ProfileImageCard;